import { useQuery } from '@tanstack/react-query';

import { getPermissions } from '../../api/permissions.api';

export const PERMISSIONS_QUERY_KEY = ['permissions'];

export const usePermissions = () => {
  return useQuery({
    queryKey: PERMISSIONS_QUERY_KEY,
    queryFn: getPermissions,
  });
};
